<template lang='pug'>
  .styling-products-hero-banner.clearfix
    a.banner-wrap.xs-12.text-center.xs-f-small.max-at-tweak(:href="settings.navTo.href" :aria-label="settings.navTo.label")
      .a-box-xs-1x1.a-box-md-4x3.styling-products-image.md-mr-150m
        .a-box-content
          img-box(:media-id="settings.mediaId")
      p.description.xs-f-small.md-f-medium.max-at-tweak.xs-text-center.md-text-left(v-html="settings.description")
      .shop-now.bold.xs-f-medium.md-f-large.max-at-tweak.xs-pt-50m.xs-pb-50m.color-mr-purple SHOP NOW

</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "StylingProductsHeroBanner",

    data() {
      return {
        settings: {
          navTo: {
            href: '/shop/styling',
            label: 'styling products'
          },
          mediaId: 6507,
          description: '<b><span style="color:#7ca3dc;">NEW</span>&nbsp;<span>Madison Reed Styling</span></b><br>Smooth strands, volumize, define curls... #hairgoals accomplished.'
        }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .styling-products-hero-banner
    position relative
    
    .banner-wrap
      color black
      padding 0 5%
      display flex
      flex-direction column
      justify-content center
      align-items center
      cursor pointer 
      margin-top -4.2em

      @media mq-desktop-md-plus
        flex-direction row
        margin-top 0

      .styling-products-image
        width 7em
        height 5.5em
        border-radius 3.5em
        border-bottom-left-radius 0%
        border-bottom-right-radius 0%
        background-color color-white

        .a-box-content
          border-top-left-radius 1.9em
          border-top-right-radius 1.9em
          width 6em
          height calc(6em*(3/4))
          transform translateX(0.5em)translateY(1em)

          @media mq-desktop-md-plus
            transform translateX(0)

        @media mq-desktop-md-plus
          width 12em
          height 9em
          border-radius 0

          .a-box-content
            border-top-left-radius 0%
            border-top-right-radius 0%
            width 12em
            height 9em

      .description
        width 80%

        @media mq-tablet
          width 60%

        @media mq-desktop-md
          width 50%

        @media mq-desktop-plus
          width 45%
      
      .shop-now
        width 80%

        @media mq-desktop-md-plus
          width 25% 

</style>
